export const STATUS_PENDENTE = 0
export const STATUS_NO_PATIO = 1
export const STATUS_NO_LEILAO = 2
export const STATUS_ABERTO = 3
export const STATUS_CLONE = 4
export const STATUS_EXCLUIR = 5
export const STATUS_FRUSTRADO = 6
export const STATUS_RETIRADO_PELO_PROPRIETARIO = 100
export const STATUS_RETIRADO_POR_LEILAO = 101
export const STATUS_RETIRADO_POR_DECISAO_JUDICIAL = 102
export const STATUS_RETIRADO_PELO_REPRESENTANTE_LEGAL = 104
export const STATUS_RETIRADO_POR_PRENSA = 105
export const STATUS_RETIRADO_POR_LEILAO_EXTERNO = 107
export const STATUS_RETIRADO_POR_ROUBO_FURTO = 108
export const STATUS_RETIRADO_POR_LEILAO_REPRESENTANTE_LEGAL = 109
export const STATUS_RETIRADO_PELO_REPRESENTANTE_LEGAL_OBITO = 110
export const STATUS_TRANSFERIDO_PATIO_CENTRAL = 200
export const STATUS_IMPORTACAO_CEVERA = 999

export const Status = {
  [STATUS_PENDENTE]: {titulo: 'Pendente', class: 'warning', color: '#ff9814'},
  [STATUS_NO_PATIO]: {titulo: 'No pátio', class: 'primary', color: '#1824ff'},
  [STATUS_ABERTO]: {titulo: 'Aberto', class: 'warning', color: '#c5cc06'},
  [STATUS_NO_LEILAO]: {titulo: 'Em leilão', class: 'info', color: '#e84118'},
  [STATUS_CLONE]: {titulo: 'Clone', class: 'info', color: '#5f27cd'},
  [STATUS_EXCLUIR]: {titulo: 'Excluir', class: 'info', color: '#b71540'},
  [STATUS_FRUSTRADO]: {titulo: 'Frustrado', class: 'info', color: '#A52A2A'},
  [STATUS_RETIRADO_PELO_PROPRIETARIO]: {titulo: 'Retirado pelo proprietário', class: 'success', color: '#00a028'},
  [STATUS_RETIRADO_POR_LEILAO]: {titulo: 'Retirado por leilão', class: 'success', color: '#22a6b3'},
  [STATUS_RETIRADO_POR_DECISAO_JUDICIAL]: {titulo: 'Retirado por decisão judicial', class: 'success', color: '#00a028'},
  [STATUS_RETIRADO_PELO_REPRESENTANTE_LEGAL]: {titulo: 'Retirado pelo representante legal', class: 'success', color: '#00b894'},
  [STATUS_RETIRADO_POR_PRENSA]: {titulo: 'Retirado por prensa', class: 'success', color: '#16a085'},
  [STATUS_RETIRADO_POR_LEILAO_EXTERNO]: {titulo: 'Retirado por leilão externo', class: 'success', color: '#000'},
  [STATUS_RETIRADO_POR_ROUBO_FURTO]: {titulo: 'Retirado por roubo/furto', class: 'success', color: '#44bd32'},
  [STATUS_RETIRADO_POR_LEILAO_REPRESENTANTE_LEGAL]: {titulo: 'Retirado por leilão pelo representante legal', class: 'success', color: '#218c74'},
  [STATUS_RETIRADO_PELO_REPRESENTANTE_LEGAL_OBITO]: {titulo: 'Retirado pelo representante legal - Óbito', class: 'success', color: '#6F1E51'},
  [STATUS_IMPORTACAO_CEVERA]: {titulo: 'Importação CEVERA', class: 'success', color: '#c44569'},
  [STATUS_TRANSFERIDO_PATIO_CENTRAL]: {titulo: 'Transferido para o pátio central', class: 'danger', color: 'red'}
}

export const StatusTitle = function (s, t) {
  t = typeof t !== 'undefined' ? t : 'titulo'
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s][t]
}

export function isRetiradoPorLeilao (status) {
  return [
    STATUS_RETIRADO_POR_LEILAO,
    STATUS_RETIRADO_POR_LEILAO_REPRESENTANTE_LEGAL
  ].includes(status)
}



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/GrvStatus.js